const isBrowser = (): boolean => typeof window !== 'undefined' && typeof localStorage !== 'undefined';

export const getLocalStorageItem = (key: string): string | null => {
    if (!isBrowser()) return null;
    return localStorage.getItem(key);
};

export const setLocalStorageItem = (key: string, value: string): void => {
    if (!isBrowser()) return;
    localStorage.setItem(key, value);
};

export const removeLocalStorageItem = (key: string): void => {
    if (!isBrowser()) return;
    localStorage.removeItem(key);
};

export const getLocalStorageJson = <T = unknown>(key: string): T | null => {
    const raw = getLocalStorageItem(key);
    if (!raw) return null;

    try {
        return JSON.parse(raw) as T;
    } catch {
        return null;
    }
};

export const setLocalStorageJson = (key: string, value: unknown): void => {
    setLocalStorageItem(key, JSON.stringify(value));
};
